<template>
    <v-row :class="[small ? 'meal-row-big' : 'meal-row']">
        <template v-if="small">
            <v-col class="meal-image-col no-padding-top no-padding-bottom" justify="center">
                <v-img v-if="meal.image !== null" :key="image" :src="image" class="meal-img big-row">
                    <template v-slot:placeholder>
                        <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                        >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                            ></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
                <v-icon v-else class="meal-img mdi-icon big-row" :class="{show: !loading}" :color="'#D3D3D3'">{{'mdi-silverware-fork-knife'}}</v-icon>
            </v-col>
            <v-col align="center">
                <v-container fill-height align="center" style="align-content: center;">
                    <v-row class="meal-menu-col no-padding-top no-padding-bottom">{{menuDescription}}</v-row>
                    <v-row class="meal-description-col no-padding-top no-padding-bottom">{{meal.description}}</v-row>
                </v-container>
            </v-col>
        </template>
        <template v-else>
            <v-col class="meal-menu-col no-padding-top no-padding-bottom">{{menuDescription}}</v-col>
            <v-col class="meal-description-col no-padding-top no-padding-bottom">{{meal.description}}</v-col>
            <v-col class="meal-image-col no-padding-top no-padding-bottom" align="right" justify="center">
                <v-img v-if="meal.image !== null" :key="image" :src="image" class="meal-img small-row">
                    <template v-slot:placeholder>
                        <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                        >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                            ></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
                <v-icon v-else class="meal-img mdi-icon small-row" :class="{show: !loading}" :color="'#D3D3D3'">{{'mdi-silverware-fork-knife'}}</v-icon>
            </v-col>
        </template>
    </v-row>
</template>
<style lang="scss">
.meal-row{
    min-height: 20vh;
    height: 20vh;
    max-height: 20vh;
}
.meal-row-big{
    min-height: 25vh;
    height: 25vh;
    max-height: 25vh;
}
.small-row {
    height: 20vh !important;
    width: 25vw;
}
.big-row {
    height: 25vh !important;
    width: 35vw;
}
.meal-img{
    border-radius: 1.2vh !important;
    transition: opacity .5s ease-in-out;
    background-color: #E5E5E5;
    object-fit: cover;
    object-position: center center;
    font-size: 10vh !important;
}
.meal-menu-col{
    font: normal normal Bold 4vh/5vh 'RobotoRegular' !important;
    color: $font-color !important;
}
.meal-description-col{
    font: normal normal normal 3vh/4vh 'RobotoRegular' !important;
    text-align: left;
    color: $font-color !important;
    flex-grow: 4;
}
.show{
    opacity: 1 !important;
}
</style>
<script>
import axios from 'axios';
export default {
    props: {
        meal: {
            type: Object,
            required: true,
        },
        menuDescription: {
            type: String,
            required: true,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            image: null
        }
    },
    created() {
        this.loadImage();
    },
    watch: {
        'meal.id': function() {
            this.image = null;
            this.loadImage();
        }
    },
    methods: {
        loadImage() {
            this.loading = true;
            if(this.meal.image !== null) {
                axios.get(this.meal.image, {
                    responseType: 'arraybuffer',
                }).then((response) => {
                    let mimetype = response.headers["Content-Type"];
                    let base64File = Buffer.from(response.data, 'binary').toString('base64');
                    this.image = "data:"+mimetype+";base64,"+ base64File;
                    this.loading = false;
                }).catch(() => {
                    this.image = null;
                    this.loading = false;
                });
            } else {
                this.image = null;
                this.loading = false;
            }
        },
    }
    
}
</script>
